module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE8SURBVHgB7VTLUcNADJVEMMnNdOB04nRAB3EHmBuHYMshd3AFJB1QAlRACXEJvnnsmeyiXfDgZAI4zHKBvJn9SVq92afRAhzx54HtJpvVKRDEsvV73i21xiXfelffEvBNc4eoY/gBtFIZL0bcnnlWhXBCU9ioldifBpYFdWSDSY2ZR0WfxMxVgIrWSHRpj9dVAKf4gIghaLEQXch8Tu/x/tulfsl3Yn0jL3r0YpOLdN2cBC5AwDah0rkmb7ztcgL9LPJO0sUwZsay6xmAA6TzYfiZz8kLbIF/k0AKvLZ9tAdOJLKQQmdJHelGTbbNDmD6R5ZCRmBes4/AVv4rLXfRiS1NT6TzM0OSdUIKM1mJNKgcgVKrZVLDQVB61W6FhKXDl6AgAto8GtvHZ5c090I1hQM+Oxm5SQpH/G+8AhNqbQKpHa2mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Images/bluevideo.png
// module id = 1178
// module chunks = 0